var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form-layout',{attrs:{"title":`${_vm.action} ${_vm.$t('product.part', 1)}`,"cols":"12","lg":"8","offset-lg":"2","xl":"6","offset-xl":"3"},on:{"submit":_vm.onSubmit}},[_c('v-form',{ref:"form"},[_c('ItemEndProductEditForm',{attrs:{"item":_vm.itemProduct}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }